import React from 'react';
import PropTypes from 'prop-types';
// import { Button } from '@mui/material';
import Button from '@mui/material/Button';
import { SimTypography } from 'components/SimTypography';

const SimButton = ({ children, backgroundColor, color, fontWeight, ...rest }) => {
	return (
		<Button
			{...rest}
			sx={{
				borderRadius: '100px',
				backgroundColor,
				fontWeight
			}}>
			<SimTypography variant='buttonText' sx={{ color: color }}>
				{children}
			</SimTypography>
		</Button>
	);
};

SimButton.propTypes = {
	children: PropTypes.node.isRequired
};

export { SimButton };
